import TopHeader from './TopHeader'
import NavbarDesktop from './menu/desktop/NavbarDesktop'
import HeaderFutureMineralsPrices from './header-future-minerals-prices/HeaderFutureMineralsPrices'
import NavbarMobile from './menu/mobile/NavbarMobile'

export default function Header() {
  return (
    <header
      data-aos="fade-down"
      className="absolute left-0 right-0 top-0 z-10"
    >
      <HeaderFutureMineralsPrices />
      <TopHeader />
      <NavbarDesktop />
      <NavbarMobile />
    </header>
  )
}
